export const de = {
  // topnav
  Search: 'Suche',
  FullScreen: 'Vollbild',
  Refresh: 'Aktualisieren',
  selected: 'ausgewählt',

  LogIn: 'Anmelden',
  LogOut: 'Abmelden',
  SignUp: 'Registrierung',
  SignIn: 'Anmeldung',

  // sidenav
  Alerts: 'Alarm',
  Heartbeats: 'Lebenszeichen',
  Users: 'Nutzer',
  Groups: 'Gruppen',
  Customers: 'Kunden',
  Blackouts: 'Blackouts',
  Permissions: 'Berechtigungen',
  APIKeys: 'API Keys',
  Searches: 'Searches',
  Labels: 'Labels',
  Reports: 'Berichte',
  More: 'Mehr',
  Settings: 'Einstellungen',
  Help: 'Hilfe',
  About: 'Über',

  // more
  ChooseDisplayDensity: 'Wähle Anzeigedichte',
  DisplayDensity: 'Anzeigedichte',
  Comfortable: 'Komfortabel',
  Compact: 'Kompakt',
  Panel: 'Panel',
  Hide: 'Verstecken',
  Show: 'Zeigen',
  DownloadAsCsv: 'Download als CSV',

  // Groups store
  UserAddedGroup: 'Nutzer zu Gruppe hinzugefügt.',
  UserRemovedGroup: 'Nutzer von Gruppe gelöscht.',

  // Preferences store
  SettingsSaved: 'Einstellungen gespeichert.',
  SettingsReset: 'Einstellungen zurückgesetzt.',
  SettingsError: 'Konnte Nutzereinstellungn nicht empfangen.',

  // Users store
  UserStatusSaved: 'Nutzerstatus gespeichert.',
  EmailSaved: 'E-Mail verifiziert.',

  // statuses
  Open: 'Offen',
  Assign: 'Zugewiesen',
  Ack: 'Bestätigt',
  Shelved: 'Aufgeschoben',
  Blackout: 'Blackout',
  Closed: 'Geschlossen',
  Expired: 'Abgelaufen',
  Unknown: 'Unbekannt',
  NotValid: 'Nicht gültig',

  // operator actions
  Open: 'Öffen',
  Assign: 'Zuweisen',
  Ack: 'Bestätigen',
  Unack: 'Unack',
  Shelve: 'Aufschieben',
  Unshelve: 'Unshelve',
  Close: 'Schließen',
  Watch: 'Beobachten',
  Unwatch: 'Nicht beobachten',
  AddNote: 'Notiz hinzufügen',
  Delete: 'Löschen',

  // Alert actions
  TextIsRequired: 'Text ist erforderlich',
  TextMustBeLessThan: 'Text muss mindestens',
  characters: 'Zeichen lang sein',

  // Alert detail
  AlertId: 'Alarm ID',
  AlertOrNoteId: 'Alarm/Notiz ID',
  LastReceiveAlertId: 'Letzte empfangene Alarm ID',
  CreateTime: 'Erstellzeit',
  ReceiveTime: 'Empfangszeit',
  LastReceiveTime: 'Letzte Empfangszeit',
  Customer: 'Kunde',
  Service: 'Service',
  Environment: 'Umgebung',
  Resource: 'Ressource',
  Event: 'Ereignis',
  Correlate: 'Korrelation',
  Group: 'Gruppe',
  Severity: 'Schweregrad',
  Status: 'Status',
  Value: 'Wert',
  Text: 'Text',
  TrendIndication: 'Trendindikator',
  Timeout: 'Zeitüberschreitung',
  Type: 'Typ',
  DuplicateCount: 'Duplikatzähler',
  Repeat: 'Wiederholung',
  Origin: 'Herkunft',
  Tags: 'Tags',
  Attributes: 'Attribute',
  History: 'Historie',
  Data: 'Daten',

  Details: 'Details',
  addedNoteOn: 'Notiz hinzugefügt an',
  by: 'von',

  // Alert history
  UpdateTime: 'Aktualisierungszeit',
  Updated: 'Aktualisiert',
  User: 'Nutzer',

  // Alert list
  Loading: 'Lädt',
  NoDataAvailable: 'Keine Daten verfügbar',
  ALL: 'ALLE',
  Description: 'Beschreibung',
  Attribute: 'Attribut',
  TimeoutLeft: 'Timeout',
  Dupl: 'Dupl.',
  PrevSeverity: 'Vorh. Schweregrad',
  Duration: 'Duration',
  LastReceiveId: 'Letze empf. ID',
  LastNote: 'Letzte Notiz',

  // Alert list filter
  Filters: 'Filter',
  FilterDescription: 'Ergebnisse durch Textsuche filtern',
  AllEnvironments: 'Alle Umgebung',
  EnvironmentDescription: 'Wähle einen oder mehrere Umgebung',
  AllSeverities: 'Alle Schweregrad',
  SeverityDescription: 'Wähle einen oder mehrere Schweregrad',
  AllStatuses: 'Alle Status',
  StatusDescription: 'Wähle einen oder mehrere Status',
  AllCustomers: 'Alle Kunden',
  CustomerDescription: 'Wähle einen oder mehrere Kunden',
  AllServices: 'Alle services',
  ServiceDescription: 'Wähle einen oder mehrere Services',
  AllGroups: 'Alle Gruppen',
  GroupDescription: 'Wähle einen oder mehrere Gruppen',

  Latest: 'Letzte',
  Hour: '1 Stunde',
  SixHours: '6 Stunden',
  TwelveHours: '12 Stunden',
  SelectRange: 'Wähle Zeitraum',

  DateTime: 'Datum/Zeit',
  StartDate: 'Startdatum',
  EndDate: 'Enddatum',
  Time: 'Zeit',
  Apply: 'Anwenden',
  Reset: 'Zurücksetzen',

  // API keys
  APIKey: 'API Key',
  Search: 'Suche',
  Customer: 'Kunde',
  Scopes: 'Bereiche',
  Expires: 'Ablauf',
  Active: 'Aktiv',
  Expired: 'Abgelaufen',
  Slow: 'Langsam',

  User: 'Nutzer',
  LastUsed: 'Zuletzt benutzt',
  Actions: 'Aktionen',

  Copy: 'Kopieren',
  Copied: 'Kopiert!',
  NewApiKey: 'Neuer API Schlüssel',
  EditApiKey: 'Bearbeite API Schlüssel',

  // Blackouts
  ChooseService: 'Wähle einen oder mehrere Services',
  Start: 'Start',
  End: 'Ende',
  Created: 'Erstellt',
  Reason: 'Ursache',
  NewBlackout: 'Neuer Blackout',
  EditBlackout: 'Bearbeite Blackout',
  Active: 'Aktiv',
  Pending: 'Offener',
  Expired: 'Abgelaufen',
  WholeEnvironment: 'Whole Environment',
  AllOrigin: 'All from Origin',

  // Customers
  LookUp: 'Nachschlagen',
  LookUpDescription: 'Nutze Login, Keycloak Rolle, GitHub org, GitLab Gruppe oder E-Mail-Domain',
  NewCustomer: 'Neuer Kunde',
  EditCustomer: 'Bearbeite Kunde',

  // Groups
  AddRemoveUsers: 'Erstellen/Lösche Nutzer',
  Addusers: 'Erstellen Nutzer',
  UsersInGroup: 'Nutzer in Gruppe',
  NumberUsers: 'Nutzeranzahl',
  NewGroup: 'Neue Gruppe',
  EditGroup: 'Bearbeite Gruppe',

  // Heartbeats
  Latency: 'Latenz',
  Since: 'Seit',

  // Manifest
  API: 'API',
  OpenGitHub: 'Öffne in GitHub',
  WebUI: 'Web UI',
  Build: 'Build',
  Date: 'Datum',
  GitRevision: 'Git Revision',
  APIEndpoint: 'API Endpoint',

  // Perms
  Role: 'Rolle',
  Scope: 'Bereich',
  SystemRole: 'Systemrolle',
  NewPermission: 'Nutzerberechtigung',
  EditPermission: 'Bearbeite Berechtigung',

  // Preferences
  ApplicationSettings: 'Applikationseinstellungen',
  DarkTheme: 'Dunkles Theme',
  PlaySounds: 'Benachrichtigungstöne abspielen',
  LanguageSettings: 'Spracheinstellungen',
  Languages: 'Sprachen',
  English: 'Englisch',
  French: 'Französisch',
  German: 'Deutsch',
  Turkish: 'Türkisch',
  DateTimeSettings: 'Datums- und Zeiteinstellungen',
  LongDate: 'Langes Datumsformat',
  MediumDate: 'Mittleres Datumsformat',
  ShortTime: 'Kurzes Zeitformat',
  DisplayMode: 'Anzeigemodus',
  UseLocal: 'Nutze lokales Datum & Zeit',
  UseUTC: 'Nutze Coordinated Universal Time (UTC)',
  AlertSettings: 'Meldungseinstellungen',
  ShowAllowedEnvs: 'Zeigen Sie immer zulässige Umgebungen an',
  ShowNotesIcon: 'Notizen-Symbol anzeigen',
  ShowNotesHint: 'Symbol neben Alarmstatus anzeigen, um eine Bedienernotiz anzuzeigen',
  Font: 'Schrift',
  FontSize: 'Schriftgröße',
  FontWeight: 'Stärke',
  PageRows: 'Zeilen pro Seite',
  rows: 'Zeilen',
  ValueWidth: 'Value Width',
  DescriptionWidth: 'Description Text Width',
  RefreshInterval: 'Aktualisierungsinterval',
  seconds: 'Sekunden',
  minutes: 'Minuten',
  AckTimeout: 'Ack timeout',
  ShelveTimeout: 'Shelve timeout',
  BlackoutSettings: 'Blackoutseinstellungen',
  BlackoutStartNow: 'Starten Sie den Zeitraum sofort',
  BlackoutPeriod: 'Blackout Zeitraum',
  hours: 'Stunden',

  // Profile
  Profile: 'Profil',
  UserID: 'User ID',
  PrimaryUserID: 'Primäre User ID',
  Provider: 'Provider',
  EmailVerified: 'E-Mail verifiziert',
  EmailNotVerified: 'E-Mail nicht verifiziert',
  Customers: 'Kunden',
  Organizations: 'Organisationen',
  Groups: 'Gruppen',
  Roles: 'Rollen',
  Scopes: 'Bereiche',
  others: 'sonstiges',

  // Status
  LastUpdate: 'Letztes Update',
  Uptime: 'Betriebszeit',
  Metric: 'Metrisch',
  Type: 'Typ',
  Name: 'Name',
  Value: 'Wert',
  AvgTime: 'Durchschn. Zeit',

  // Users
  Active: 'Aktiv',
  Inactive: 'Inaktiv',
  Login: 'Login',
  Email: 'E-Mail',
  Verified: 'Verifiziert',
  Comment: 'Kommentar',
  VerifiedOrNot: 'Verifiziert?',
  LastLogin: 'Letzter Login',
  NewUser: 'Neuer Nutzer',
  EditUser: 'Bearbeite Nutzer',

  // Reports
  Top: 'Top',
  Flapping: 'Flapping',
  Offenders: 'Offenders',
  Standing: 'Standing',
  TopFlappingDescription: 'Chattering and fleeting alert sources that have generated the most number of alert severity changes.',
  TopOffendersDescription: 'Frequently occurring alert sources that have generated the most number of alerts and alert duplicates.',
  TopStandingDescription: 'Stale alert sources that have active alerts for a prolonged duration.',
  
  Count: 'Anzahl',
  DuplCount: 'Dupl. Anzahl',
  Services: 'Services',
  Resources: 'Ressourcen',

  // User Confirm
  Thanks: 'Danke!',
  YouCanNowLogin1: 'Sie können sich jetzt',
  YouCanNowLogin2: 'anmelden.',
  EmailConfirmFailed: 'Entschuldigung, es gab ein Problem bei der Verifizierung Ihrer E-Mail-Adresse',
  TryAgain: 'Bitte erneut versuchen',

  // User Forgot
  ResetLink: 'E-Mail eingeben um einen Rücksetzungs-Link zu erhalten',
  AlreadyHaveAccount: 'Haben sie bereits ein Konto?',
  CheckEmail: 'Überprüfen Sie Ihre E-Mail auf einen Rücksetzungs-Link...',
  ReturnSignIn: 'Zurück zur Anmeldung',
  ResetEmailSent: 'Rücksetzungs-Mail erfolgreich gesendet!',

  // User Login
  LoginToContinue: 'Bei Alerta anmelden um fortzufahren',
  Username: 'Nutzername',
  Password: 'Passwort',
  CreateAccount: 'Account erstellen',
  ForgotPassword: 'Passwort vergessen?',
  UnspecifiedProblem: 'Entschuldigung, es gab ein Problem',
  AuthWith: 'Authentifiziere mit',
  AuthInProgress: 'Authentifiziere...',
  AuthNotPossible: 'Entschuldigung, Authentifizierung nicht möglich',
  AuthProviderUnknown: 'Unbekannter Authentifizierungsanbieter',

  // User Logout
  LoggedOut: 'Sie wurden abgemeldet.',

  // User Reset
  ChooseNewPassword: 'Neues Passwort auswählen',
  ConfirmPassword: 'Passwort bestätigen',
  ResetPassword: 'Passwort zurücksetzen',

  // User Signup
  CreateAlertaAccount: 'Erstellen Sie Ihr Alerta-Konto',
  SignUpNotAvailable: 'Entschuldigung, die Anmeldung ist derzeit nicht möglich',
  FullName: 'Voller Name',
  Min6Char: 'Min. 6 Zeichen',
  PasswordNotMatch: 'Passwörter stimmen nicht überein',

  // Labels
  scope: 'Bereich',
  role: 'Rolle',
  customer: 'Kunde',
  group: 'Gruppe',

  // General
  ConfirmDelete: 'Sind Sie sicher, dass Sie diesen Punkt löschen möchten?',
  Error: 'Fehler',
  Send: 'Senden',
  Required: 'Erforderlich',
  Cancel: 'Abbrechen',
  Save: 'Speichern',
  NoDisplay: 'Entschuldigung, hier gibt es nichts zu sehen :(',
  SearchNoResult1: 'Ihre Suche nach ',
  SearchNoResult2: 'hat nichts gefunden.',
  OK: 'OK',

  // ENDS.
}
